export enum IntegrationWebhookMessageTypeEnum {
  MAINTENANCE_REQUESTED = 'MAINTENANCE_REQUESTED',
  MAINTENANCE_ON_NEGOTIATION = 'MAINTENANCE_ON_NEGOTIATION',
  MAINTENANCE_PENDING = 'MAINTENANCE_PENDING',
  MAINTENANCE_SCHEDULED = 'MAINTENANCE_SCHEDULED',
  MAINTENANCE_IN_PROGRESS = 'MAINTENANCE_IN_PROGRESS',
  MAINTENANCE_REPORTED = 'MAINTENANCE_REPORTED',
  MAINTENANCE_COMPLETED = 'MAINTENANCE_COMPLETED',
  MAINTENANCE_CANCELED = 'MAINTENANCE_CANCELED',
  FORM_UPDATED = 'FORM_UPDATED',
}

export enum IntegrationWebhookAuthenticationTypeEnum {
  BASIC = 'BASIC',
  NONE = 'NONE'
}
